import React, {Component} from 'react'
import {Button, Popover,Icon,Input,Form,Row,Col,Radio} from "antd";
import "./route.less"
import "./route-line.less"
const EditableContext = React.createContext();
class RouteEditStep  extends Component {

    constructor(props, context) {
        super(props, context);
        this.state={
            nodes:[],
            editingIndex:-1,
            routeName:"",
            routeType:'O',
        }
    }

    addNode=()=>{
        let newNodes = [...this.props.nodes]
        newNodes.splice(-1,0,{name:"请输入节点名"+(newNodes.length+1),editable:true,deletable:true})
        this.setState({
            nodes:newNodes,
        });
    }
    delNode=(index)=>{
        let newNodes = [...this.props.nodes[this.props.routeType]]
        newNodes.splice(index, 1);
        let newAll = Object.assign(this.props.nodes,{[this.props.routeType]:newNodes})
        this.props.updateNodes(newAll);
    }
    saveNode=(form,index)=>{
        form.validateFields((error, value) => {
            if (error) {
                return;
            }
            let newNodes = [...this.props.nodes[this.props.routeType]]
            let node = newNodes[index]
            let newNode = Object.assign(node,value)
            newNodes.splice(index, 1,{
                ...node,
                ...newNode,
            });
            let newAll = Object.assign(this.props.nodes,{[this.props.routeType]:newNodes})
            this.props.updateNodes(newAll);
            this.setState({
                editingIndex:-1
            })
        });
    }
    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <EditableContext.Provider value={this.props.form}>
                <div className='order-info box-shadow padding-20'>
                    <div className={"routeBox processShow"}>
                        {this.props.nodes[this.props.routeType].map((node,index)=>{
                            return (
                                <div className={this.props.routeType+""==="I"?'routeIteamLine finish':'routeIteamLine finish'} >
                                    <div className="info">
                                        <div className={node.editable?"circle editable":"circle"}><i></i></div>
                                        {this.state.editingIndex===index?(
                                            <div>
                                                <Form.Item style={{ margin: 0 }} wrapperCol= {{span:24}}>
                                                    {getFieldDecorator('name', {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: `请输入!`,
                                                            },
                                                        ],
                                                        initialValue: node.name,
                                                    })(<Input style={{textAlign:"center"}}/>)}
                                                </Form.Item>
                                                <EditableContext.Consumer>
                                                    {form => (
                                                        <a
                                                            onClick={() => this.saveNode(form, index)}
                                                            style={{marginRight: 8}}
                                                        >
                                                            保存
                                                        </a>
                                                    )}
                                                </EditableContext.Consumer>
                                                <a
                                                    onClick={()=>{this.setState({
                                                        editingIndex:-1
                                                    })}}
                                                >取消</a>
                                            </div>
                                        ):(!this.props.readOnly&&node.editable&&this.state.editingIndex===-1?(
                                                <Popover
                                                    placement="bottom"
                                                    content={(
                                                        <span>
                                                    <a
                                                        style={{marginRight: 8}}
                                                        onClick={()=>{this.setState({
                                                            editingIndex:-1
                                                        },()=>{
                                                            this.setState({
                                                                editingIndex:index
                                                            })})}}
                                                    ><Icon type="edit" /></a>
                                                            {node.deletable?(
                                                                <a
                                                                    onClick={()=>{this.delNode(index)}}
                                                                ><Icon type="delete" /></a>
                                                            ):(null)}
                                                </span>
                                                    )}
                                                >
                                                    <div className="title">{node.name}</div>
                                                </Popover>
                                            ):(
                                                node.insert==='left'||node.insert==='both'?(
                                                    <Popover
                                                        placement="bottom"
                                                        content={(
                                                            <span>
                                                    <a
                                                        style={{marginRight: 8}}
                                                        onClick={()=>{this.setState({
                                                            editingIndex:-1
                                                        },()=>{
                                                            this.setState({
                                                                editingIndex:index
                                                            })})}}
                                                    ><Icon type="left" /></a>
                                                </span>
                                                        )}
                                                    >
                                                        <div className="title">{node.name}</div>
                                                    </Popover>
                                                ):(
                                                    <div className="title">{node.name}</div>
                                                )

                                            )
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </EditableContext.Provider>
        );
    }
}
const RouteEditStepForm = Form.create()(RouteEditStep)
export default RouteEditStepForm